import React, { useState, useEffect } from "react";
import PageLayout from "../../components/PageLayout";
import Table from "../../components/Table";
import Button from "../../components/Button";
import DeleteConfirmation from "../../components/DeleteConfirmation";

import FacilityAddEdit from "../../components/AddEditItems/FacilityAddEdit";

import Toast from "../../components/Toast";
import SearchIcon from "../../icons/pos_find.png";

import IconAdd from "../../icons/rev_add_group.png";
import IconSearch from "../../icons/pos_find.png";
import CaretIcon from "../../icons/rev_carat.png";
import HeaderIcon from "../../icons/newicons/geo.svg";
import HeaderIconSvg from "../../icons/newicons/arrow-down-up.svg";
import Toggle from "react-toggle";

import {
  GET_FACILITIES_URL,
  ADD_FACILITIES_URL,
  EDIT_FACILITIES_URL,
  DELETE_FACILITIES_URL,
  FILE_UPLOAD_URL,
  getData,
  postData,
  putData,
  deleteData,
  uploadFile,
  GET_ENTITIES_URL,
} from "../../utils/api";

import { getLoginDetails } from "../../utils/storage";

const facilityModel = {
  name: "",
  address: "",
  city: "",
  state: "",
  zipcode: "",
  email: "",
  firstName: "",
  lastName: "",
  phone: "",
  isActive: true,
};

// const entityModel={
//     "companyName": "First Organisation",
//     "companyLogo": "http://a.b",
//     "companyType": "BUYER",
//     "isPartner": true,
//     "address": "company address",
//     "city": "company city",
//     "state": "company state",
//     "zipcode": "560043",
//     "email": "company email",
//     "phone": "company phone",
//     "firstName": "first name",
//     "lastName": "last name"
// }

export const Facilities = (props) => {
  const { hierarchy, companyId = false } = getLoginDetails();
  const [facilitiesItems, setFacilitiesItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [isAddPopupShown, setIsAddPopupShown] = useState(false);
  const [isEditPopupShown, setIsEditPopupShown] = useState(false);
  const [isDeletePopupShown, setIsDeletePopupShown] = useState(false);
  const [itemForEdit, setItemForEdit] = useState(null);
  const [itemForDelete, setItemForDelete] = useState(null);

  const [entitiesItems, setEntitiesItems] = useState([]);
  const [franchise, setFranchise] = useState("");
  const [showFranchiseDropdownDiv, setShowFranchiseDropdownDiv] = useState(
    false
  );

  const[isFacility, setIsFacility] = useState(false);

  const [params, setParams] = useState({
    limit: 10,
    offset: 0,
    areMoreItemsAvailable: false,
    text: "",
  });
  const [toastParams, setToastParams] = useState({
    message: "",
    type: "",
    id: "",
  });

  const getFacilities = async (companyId = false) => {
    try {
      setIsLoading(true);
      // setFacilitiesItems([]);
      const payload = {
        count: params.limit,
        offset: params.offset,
        text: params.text,
        isFacility
        // parentCompanyId: props.parentCompanyId || getLoginDetails().parentCompanyId
      };
      if (companyId) {
        payload.companyId = companyId;
      }
      const data = await getData(GET_FACILITIES_URL, payload);
      setIsLoading(false);

      setFacilitiesItems(
        (data.list || []).sort((a, b) => (a.name > b.name && 1) || -1)
      );
      setParams({
        ...params,
        areMoreItemsAvailable: data.areMoreItemsAvailable,
      });
    } catch (e) {
      console.log("ERROR", e);
    }
  };
  useEffect(() => {
    getFacilities();
  }, [params.offset, params.text, params.limit,isFacility]);

  // useEffect(()=> {
  //     getEntities();
  // }, [params.offset]);

  const fetchMore = () => {
    setParams({
      ...params,
      offset: params.offset + params.limit,
    });
  };
  const fetchLess = () => {
    setParams({
      ...params,
      offset: params.offset - params.limit,
    });
  };
  const onSearchChange = (text) => {
    setParams({
      ...params,
      text,
      offset: 0,
    });
  };
  const addItem = async (data, image) => {
    let { companyLogo } = data;
    setIsLoading(true);
    try {
      if (image) {
        const response = await uploadFile(FILE_UPLOAD_URL, image.file);
        companyLogo = response.imageUrl;
      }
      const response = await postData(ADD_FACILITIES_URL, {
        ...data,
        companyLogo,
        parentCompanyId:
          props.parentCompanyId || getLoginDetails().parentCompanyId,
      });
      setIsAddPopupShown(false);
      setToastParams({
        type: "SUCCESS",
        message: "Successfully added the Facility",
        id: new Date().getTime(),
      });
      setIsLoading(false);
      getFacilities();
    } catch (e) {
      console.log("ERROR");
      setToastParams({
        type: "ERROR",
        message:
          e && e.error
            ? e.error
            : e && e.response && e.response.data && e.response.data.error
            ? e.response.data.error
            : "Oops! Something went wrong. Please try again later",
        id: new Date().getTime(),
      });
      setIsLoading(false);
    }
  };
  const editItem = async (data, image) => {
    let { companyLogo } = data;
    setIsLoading(true);
    try {
      if (image) {
        const response = await uploadFile(FILE_UPLOAD_URL, image.file);
        companyLogo = response.imageUrl;
      }
      const response = await putData(EDIT_FACILITIES_URL, {
        ...data,
        companyLogo,
        parentCompanyId:
          props.parentCompanyId || getLoginDetails().parentCompanyId,
      });
      setIsEditPopupShown(false);
      setToastParams({
        type: "SUCCESS",
        message: "Successfully edited the Facility",
        id: new Date().getTime(),
      });
      setIsLoading(false);
      getFacilities();
    } catch (e) {
      console.log("ERROR");
      setToastParams({
        type: "ERROR",
        message:
          e && e.error
            ? e.error
            : e && e.response && e.response.data && e.response.data.error
            ? e.response.data.error
            : "Oops! Something went wrong. Please try again later",
        id: new Date().getTime(),
      });
      setIsLoading(false);
    }
  };
  const onIsActiveChange = (item, isActive) => {
    editItem({
      ...item,
      isActive,
    });
  };
  const deleteItem = async () => {
    try {
      const response = await deleteData(DELETE_FACILITIES_URL, {
        facilityId: itemForDelete.facilityId,
      });
      setIsDeletePopupShown(false);
      getFacilities();
    } catch (e) {
      setIsDeletePopupShown(false);
      setToastParams({
        type: "ERROR",
        message:
          e && e.error
            ? e.error
            : e && e.response && e.response.data && e.response.data.error
            ? e.response.data.error
            : "Oops! Something went wrong. Please try again later",
        id: new Date().getTime(),
      });
      console.log("ERROR");
    }
  };
  const setEdit = (item) => {
    setIsEditPopupShown(true);
    setItemForEdit(item);
  };
  const setDelete = (item) => {
    setIsDeletePopupShown(true);
    setItemForDelete(item);
  };

  const getEntities = async (text, isFranchise = false) => {
    try {
      const data = await getData(GET_ENTITIES_URL, {
        count: 500,
        offset: 0,
        text,
        parentCompanyId: getLoginDetails().parentCompanyId,
        isEmbed: false,
        isFranchise,
      });
      setEntitiesItems(data.list);
    } catch (e) {
      console.log("ERROR", e);
    }
  };

  return (
    <PageLayout
      icon={HeaderIconSvg}
      onSearchChange={onSearchChange}
      heading="Facilities"
      searchPlaceholder="Search Facility"
      hideSearchBar={true}
    >
      {!isAddPopupShown && !isEditPopupShown && (
        <div className="flex flex-middle mb-16 mt-8 flex-between">
          <div className="flex flex-between flex-middle">
            {/* <img src={IconSearch} className="ht-30 wt-30 mr-12" />
                    <h1 className="mr-24 fs-20 c-gray">VIEW FACILITIES</h1> */}
          </div>
          {facilitiesItems.length > 0 &&
            (params.offset >= 10 || params.areMoreItemsAvailable) && (
              <div className="ht-60 flex flex-middle flex-center pl-16 pr-16 pagination-wrapper">
                <div className="bg-gray flex flex-center flex-middle pr-8 pb-4 pt-4">
                  <img
                    src={CaretIcon}
                    alt=""
                    className={`wt-20 rotate-90 c-pointer ${
                      params.offset > 0 ? "op-7" : "op-2"
                    }`}
                    onClick={params.offset > 0 ? fetchLess : () => {}}
                  />
                </div>
                <span className="fs-14 c-gray mr-20 ml-20 fw-bold">
                  Showing {params.offset + 1} -{" "}
                  {params.offset + facilitiesItems.length}
                </span>
                <div className="bg-gray flex flex-center flex-middle pl-8 pb-4 pt-4">
                  <img
                    src={CaretIcon}
                    alt=""
                    className={`wt-20 rotate--90 c-pointer ${
                      params.areMoreItemsAvailable ? "op-7" : "op-2"
                    }`}
                    onClick={
                      params.areMoreItemsAvailable ? fetchMore : () => {}
                    }
                  />
                </div>
              </div>
            )}
          {/* <Button type="secondary" onClick={()=> {setIsAddPopupShown(true)}}>Add item</Button> */}
          <div className="flex flex-middle flex-between">
            {hierarchy === 1 && (
              <div
                className="franchise-filter costSheetFilters"
                style={{ boxShadow: "none", margin: 0, background: 'transparent' }}
              >
                <div className="mb-16"> </div>
               
                <div className=" p-relative ">

                  <div className="flex">
                    <img
                      src={SearchIcon}
                      className="wt-20 t-8 p-absolute l-8"
                    />
                    <input
                      value={franchise}
                      className=" form-control top_form_input forminput fs-16  ht-35 search pl-32"
                      placeholder="Franchise Filter"
                      style={{ paddingLeft: 35 }}
                      onChange={(e) => {
                        setFranchise(e.target.value);
                        if ((e.target.value || "").length > 2) {
                          getEntities(e.target.value, true);
                          setShowFranchiseDropdownDiv(true);
                        }
                      }}
                    />
                    <div className="search-button ml-8">
                      <div
                        className="wt-35 ht-35 rounded-circle  align-center d-flex justify-content-center align-items-center  closeicon pl-4 pr-4 pb-8 pt-8 c-white fw-bolder c-pointer"
                        onClick={() => 
                          {setFranchise("");
                          setEntitiesItems([]);
                          getFacilities();
                        }
                      }
                      >
                        <span className="fs-16 c-white"> X </span>
                      </div>
                    </div>
                    <p className="ml-10 ">Is Franchise</p>
                    <div className="ml-10 ">
                    {/* <div className="">Is Facility?</div> */}
                    <Toggle
                      className="bg-theme"
                      onChange={(e) => {
                        setIsFacility(e.target.checked);
                      }}
                      checked={isFacility}
                    />
                  </div>
                  </div>
                  {showFranchiseDropdownDiv && entitiesItems.length > 0 && (
                    <div className="p-absolute z-1 border-black">
                      <div
                        className="pl-8 pr-8 bg-lt-gray wt-200 z-1 max-ht-300 "
                        style={{ overflow: "scroll" }}
                      >
                        {[...entitiesItems].map((item) => {
                          return (
                            <div
                              key={item.companyId}
                              className="flex selectListDiv c-pointer"
                              onClick={() => {
                                setShowFranchiseDropdownDiv(false);
                                setEntitiesItems([]);
                                setFranchise(item.companyName);
                                getFacilities(item.companyId);
                              }}
                            >
                              <div className="fs-14 mb-4">
                                {item.companyName}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
            <div
              className="btn ht-40 bg-gray pl-8 pr-8 pb-8 pt-8 c-white fw-bolder c-pointer"
              onClick={() => {
                setIsAddPopupShown(true);
              }}
            >
              <img src={IconAdd} className="ht-20 wt-20 mr-12" />
              <span>Add Facilitiy</span>
            </div>
          </div>
        </div>
      )}
      {!isAddPopupShown && !isEditPopupShown && (
        <Table
          scrollTable={true}
          type="entity"
          columns={[
            "Facility Name",
            // 'User name',
            // "Director First Name",
            "Director Last Name",
            "Address",
            "Phone",
            "Status",
          ]}
          // className="wt-600"
          items={facilitiesItems.map((facility) => {
            return {
              ...facility,
              displayAddress: `${facility.address || ""} ${facility.city} ${
                facility.state
              } ${facility.zipcode}`,
              displayName: `${facility.firstName || ""} ${facility.lastName}`,
            };
          })}
          keys={["name", "lastName", "displayAddress", "phone", "isActive"]}
          widthClasses={[
            "wt-250",
            "wt-250",
            "wt-300",
            "wt-300",
            "wt-100",
            "wt-100",
          ]}
          actions={["EDIT", "DELETE"]}
          onEdit={setEdit}
          onDelete={setDelete}
          onChange={onSearchChange}
          onIsActiveChange={onIsActiveChange}
          offset={params.offset}
          areMoreItemsAvailable={params.areMoreItemsAvailable}
          fetchMore={fetchMore}
          fetchLess={fetchLess}
          isLoading={isLoading}
          hideCheckBox={true}
          onCountChange={(value) => {
            setParams({
              ...params,
              offset: 0,
              limit: value,
            });
          }}
          limit={params.limit}
          switchIds={[4]}

          // widthClasses={['wt-200', 'wt-200', 'wt-150', 'wt-300', 'flex-1']}
        />
      )}
      {isAddPopupShown && (
        <FacilityAddEdit
          isLoading={isLoading}
          item={{ ...facilityModel }}
          onClose={setIsAddPopupShown.bind(null, false)}
          onBack={setIsAddPopupShown.bind(null, false)}
          onSave={addItem}
          type="add"
          shouldShowPriceMod={getLoginDetails().hierarchy === 1}
        />
      )}
      {isEditPopupShown && (
        <FacilityAddEdit
          isLoading={isLoading}
          item={{ ...itemForEdit }}
          onClose={setIsEditPopupShown.bind(null, false)}
          onBack={setIsEditPopupShown.bind(null, false)}
          onSave={editItem}
          type="edit"
          shouldShowPriceMod={getLoginDetails().hierarchy === 1}
        />
      )}
      {isDeletePopupShown && (
        <DeleteConfirmation
          type="facility"
          name={itemForDelete.name}
          onClose={setIsDeletePopupShown.bind(null, false)}
          onConfirm={deleteItem}
        />
      )}
      <Toast
        type={toastParams.type}
        message={toastParams.message}
        id={toastParams.id}
      />
    </PageLayout>
  );
};

export default Facilities;
